import React from "react";
import styles from './OrderLifeCycle.module.css';

const OrderLifeCycle = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>Order Life Cycle</h1>
        </div>
        
        <div className={styles.contentCard}>
          <div className={styles.welcomeText}>Hello World! - order life cycle page</div>
          <div className={styles.subText}>This is the Order Life Cycle page. Your content will go here.</div>
        </div>
      </div>
    </div>
  );
};

export default OrderLifeCycle;